import {applySnapshot, destroy, getSnapshot, Instance, types} from "mobx-state-tree";
import {Image, ImageDefaultStore} from './models'

const OnboardingStore = types
    .model({
        title: types.string,
        subtitle: types.string,
        color: types.string,
        image: types.maybeNull(Image),
        backgroundColor: types.string,
        backgroundImage: types.maybeNull(Image)
    })
    .views(self => ({
        get canProceed(): boolean {
            if (self.image && !self.image.isLoaded)
                return false;
            if (self.backgroundImage && !self.backgroundImage.isLoaded)
                return false;
            return this.hasScreen;
        },
        get hasScreen(): boolean {
            return !!(self.title || self.subtitle || self.image || self.backgroundImage || self.backgroundColor);
        },
        get imagesAreValid() {
            if (self.image && !self.image.isUploaded) {
                return false
            }
            return !(self.backgroundImage && !self.backgroundImage.isUploaded);
        },
        get allText() {
            return `${self.title} ${self.subtitle}`
        },
        get view() {
            return {
                title: self.title,
                subtitle: self.subtitle,
                image: self.image ? self.image.url : "",
                backgroundImage: self.backgroundImage ? self.backgroundImage.url : "",
                backgroundColor: self.backgroundColor || "#ffffff",
                fontColor: self.color,
            }
        }
    }))
    .actions(self => {
        let initialState = {};
        return {
            afterCreate() {
                initialState = getSnapshot(self);
            },
            reset: () => {
                applySnapshot(self, initialState);
            },
            reUploadAll: function () {
                self.backgroundImage && self.backgroundImage.reupload();
                self.image && self.image.reupload();
            },
            removeImage() {
                if (self.image) {
                    destroy(self.image)
                }
                self.image = null;
            },
            removeBackgroundImage() {
                if (self.backgroundImage) {
                    destroy(self.backgroundImage)
                }
                self.backgroundImage = null;
            },
            setTitle: function (value: string) {
                self.title = value
            },
            setSubtitle: function (value: string) {
                self.subtitle = value
            },
            setColor: function (value: string) {
                self.color = value
            },
            setBackgroundColor: function (value: string) {
                self.backgroundColor = value
            },
            setURLImage: function (value: string) {
                if (self.image) {
                    destroy(self.image)
                }
                self.image = Image.create({...ImageDefaultStore, path: value, isLocalImage: false})
                self.image.upload()
            },
            setLocalImage: function (file: File | null) {
                if (self.image) {
                    destroy(self.image)
                }
                if (!file) {
                    // prevent some typescript issue
                    return
                }
                self.image = Image.create({...ImageDefaultStore, path: URL.createObjectURL(file), isLocalImage: true});
                self.image.setFile(file);
                self.image.upload();
            },
            setURLBackgroundImage: function (value: string) {
                if (self.backgroundImage) {
                    destroy(self.backgroundImage)
                }
                self.backgroundImage = Image.create({...ImageDefaultStore, path: value, isLocalImage: false});
                self.backgroundImage.upload()
            },
            setLocalBackgroundImage: function (file: File) {
                if (self.backgroundImage) {
                    destroy(self.backgroundImage)
                }
                self.backgroundImage = Image.create({
                    ...ImageDefaultStore,
                    path: URL.createObjectURL(file),
                    isLocalImage: true
                });
                self.backgroundImage.setFile(file);
                self.backgroundImage.upload();
            },
        }
    });

export interface IOnboardingStore extends Instance<typeof OnboardingStore> {
}

export const OnboardingDefaultStore = {title: '', subtitle: '', color: '', backgroundColor: ''};

export default OnboardingStore;
